import { render, staticRenderFns } from "./cModalDetalle.vue?vue&type=template&id=03f34257&scoped=true"
import script from "./cModalDetalle.vue?vue&type=script&lang=js"
export * from "./cModalDetalle.vue?vue&type=script&lang=js"
import style0 from "./cModalDetalle.vue?vue&type=style&index=0&id=03f34257&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f34257",
  null
  
)

export default component.exports